import * as React from 'react';
class SearchContainer extends React.Component {
  constructor(...args) {
    super(...args);
    // @ts-expect-error - TS2564 - Property 'canHandleResults' has no initializer and is not definitely assigned in the constructor.
    this.canHandleResults = void 0;
    this.state = {
      queryString: '',
      results: [],
      status: 'initial',
      lastQueryTime: null
    };
    this.handleChange = value => {
      this.setState({
        queryString: value
      }, () => {
        this.handleResults(this.props.query, value);
      });
    };
  }
  componentDidMount() {
    this.canHandleResults = true;
    this.handleResults(this.props.query, this.state.queryString);
  }
  componentDidUpdate(prevProps) {
    if (this.props.query !== prevProps.query) {
      this.handleResults(this.props.query, this.state.queryString);
    }
  }
  componentWillUnmount() {
    this.canHandleResults = false;
  }
  handleResults(query, queryString) {
    const queryTime = Date.now();
    this.setState({
      status: 'loading',
      lastQueryTime: queryTime
    }, () => {
      query(queryString).then(results => {
        if (this.canHandleResults && this.state.lastQueryTime === queryTime) {
          this.setState({
            results,
            status: 'completed'
          });
        }
      }, reason => {
        if (this.canHandleResults && this.state.lastQueryTime === queryTime) {
          this.setState({
            results: [],
            status: 'error'
          });
        }
      });
    });
  }
  render() {
    const {
      children
    } = this.props;
    const {
      status
    } = this.state;
    return children({
      onChangeQuery: this.handleChange,
      queryString: this.state.queryString,
      results: this.state.results,
      status
    });
  }
}
export default SearchContainer;